import { useHasFeatureFlag } from 'bringg-web';
import { ENABLE_IMPROVED_EXCLUSION_WINDOWS_UX } from '../constants';

export const useEnableImprovedExclusionWindowsUx = () => useHasFeatureFlag(ENABLE_IMPROVED_EXCLUSION_WINDOWS_UX);
